import React, { useState } from 'react'
import { Dialog, Tooltip, IconButton } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import EditIcon from '@material-ui/icons/Edit'
import EdicionDemora from './EdicionDemora'

function EdicionDemoraEnVolcadora (props) {
  const { data, updateDemora } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='md'
        fullWidth
      >
        <DialogView
          confirmCallback={updateDemora}
          cancelCallback={handleClose}
          title='Editar demora en volcadora'
          content={<EdicionDemora data={data} />}
        />
      </Dialog>

      <Tooltip title={'Editar'}>
        <IconButton onClick={handleOpen}>
          <EditIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}

export default EdicionDemoraEnVolcadora
